import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

export function DocumentItem({
  name,
  size,
  invalid = false,
  invalidMessage,
  onClick = () => { },
  onRemove
}:
  {
    name: String;
    size: number;
    onClick?: Function;
    onRemove?: Function;
    invalid?: Boolean;
    invalidMessage?: string;

  }) {

  const fileType = (fileName: any) => {
    return fileName.substring(fileName.lastIndexOf('.') + 1, fileName.length) || fileName;
  };
  const fileSize = (size: any) => {
    if (size === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(size) / Math.log(k));
    return parseFloat((size / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  };
  return (
    <div className="file-status-bar" >
      <div onClick={() => onClick?.() ?? null}>
        <div className="file-type-logo"></div>
        <div className="file-type">{fileType(name)}</div>
        <span className={`file-name ${invalid ? 'file-error' : ''}`}>{name}</span>
        <span className="file-size">({fileSize(size)})</span>
        {invalid && invalidMessage && <span className="file-error-message ml-1">({invalidMessage})</span>}
      </div>
      {onRemove?<div className="file-remove" onClick={() => onRemove?.() ?? null} ><FontAwesomeIcon icon={faTimes as IconProp} /></div>:null}
    </div>
  )
}